/*
 *
 * Notification reducer
 *
 */
import produce from 'immer';
import { ADD_FLAG, REMOVE_FLAG } from './constants';

export const initialState = [];

/* eslint-disable default-case, no-param-reassign */
const notificationReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case ADD_FLAG:
        draft.unshift(action.payload);
        break;
      case REMOVE_FLAG:
        draft.shift();
        break;
    }
  });
};

export default notificationReducer;
